/**
 * Single source of truth for environment-specific configuration.
 *
 * Every value comes from `process.env.REACT_APP_*`, falling back to the current
 * production value. So if a var is not set, the app behaves exactly as it did
 * before.
 *
 * To change an environment, don't touch the code — change the value in
 * `.env.development` / `.env.production`. (CRA reads env vars only at startup,
 * so the dev server needs a restart.)
 *
 * NOTE: react-scripts replaces `process.env.REACT_APP_X` by matching literal
 * text at build time. Dynamic access (`process.env[name]`) will never work —
 * every access below must be literal.
 */

const pick = (value, fallback) =>
  value && value.trim() ? value.trim() : fallback;

export const APP_ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV;

export const API = {
  // AWS API Gateway — platform (auth, mentors, groups, meetings, conv)
  PLATFORM: pick(
    process.env.REACT_APP_PLATFORM_API_URL,
    "https://8075290rn4.execute-api.us-east-1.amazonaws.com/dev/"
  ),

  // api.collegeit.in/service — mentors info / query / connect
  SERVICE: pick(
    process.env.REACT_APP_SERVICE_API_URL,
    "https://api.collegeit.in/service/"
  ),

  // api.collegeit.in/api — webcall, conversation-isrc, video-analytics
  // (video-analytics really does live under /api/api — that is not a typo)
  CORE: pick(process.env.REACT_APP_CORE_API_URL, "https://api.collegeit.in/api"),

  // AWS API Gateway — leads / mentor performance
  CONVERSATION: pick(
    process.env.REACT_APP_CONVERSATION_API_URL,
    "https://u2ga9t2hkh.execute-api.us-east-1.amazonaws.com/conversation/"
  ),

  // legacy ap-south-1 gateway — only CallOverview/EmailDashboard Conversation.js
  WEBCALL_LEGACY: pick(
    process.env.REACT_APP_WEBCALL_LEGACY_API_URL,
    "https://ok1qlahe4k.execute-api.ap-south-1.amazonaws.com"
  ),

  // IMG_UPLOAD is gone: image upload moved into the platform api itself
  // (POST /mentors/image), so there is no standalone upload service to point at
  // and no IMG_AUTH secret to ship in this bundle

  RETELL: pick(process.env.REACT_APP_RETELL_API_URL, "https://api.retellai.com"),
};

export const KEYS = {
  RETELL_BEARER: process.env.REACT_APP_BEARER_TOKEN,
  OPENAI: process.env.REACT_APP_OPENAI_API_KEY,
};

export const AGENTS = {
  ISRC_CALLS: pick(
    process.env.REACT_APP_RETELL_AGENT_CALLS,
    "agent_fc285818609257e75b1bb46483"
  ),
  ISRC_CHATS: pick(
    process.env.REACT_APP_RETELL_AGENT_CHATS,
    "agent_f0dc2b661cbb4be0eb356fd888"
  ),
};

export const ANALYTICS = {
  GA_TRACKING_ID: pick(process.env.REACT_APP_GA_TRACKING_ID, "UA-208900493-1"),
  WISTIA_PROJECT_ID: pick(
    process.env.REACT_APP_WISTIA_PROJECT_ID,
    "mn2xw35uu2"
  ),
};

export const SITE = {
  MARKETING: pick(
    process.env.REACT_APP_MARKETING_URL,
    "https://www.collegeit.org"
  ),
  MARKETING_M: pick(
    process.env.REACT_APP_MARKETING_M_URL,
    "https://www.m.collegeit.org"
  ),
  PORTAL: pick(
    process.env.REACT_APP_PORTAL_URL,
    "https://portal.collegeit.org"
  ),
};
